import {
  personalizationInitialState,
  reducer as personalization,
} from "./personalization";

import { bookmarkInitialState, reducer as bookmark } from "./bookmark";
import {
  followedContentInitialState,
  reducer as followedContent,
} from "./followedContent";
import { defaultInitialState, reducer as defaultReducer } from "./default";

//the name of the reducer in "reducers" object below has to be the same
//as the name of initial state of this reducer in "initialState" object below
export const initialState = {
  personalization: personalizationInitialState,
  bookmark: bookmarkInitialState,
  followedContent: followedContentInitialState,
  default: defaultInitialState,
};

const reducers = {
  personalization,
  bookmark,
  followedContent,
  default: defaultReducer,
};

//TODO: This has been copied from other MFE.
//Evaluate the approach and may be replace with better
export const combineReducers = (reducersObj) => {
  return (state, action) => {
    return Object.keys(reducersObj).reduce((nextState, key) => {
      nextState[key] = reducersObj[key](state[key], action);
      return nextState;
    }, {});
  };
};
export const reducer = combineReducers(reducers);
